import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehouseUnitTypesAdapter = getAdapter({ idFieldName: 'value' });

const warehouseUnitTypesSlice = createSlice({
  name: 'warehouseUnitTypes',
  initialState: warehouseUnitTypesAdapter.getInitialState(),
  reducers: {
    setWarehouseUnitTypes: (state, { payload: { unitTypes } }) => {
      warehouseUnitTypesAdapter.setAll(state, unitTypes);
    },
  },
});

const selectors = warehouseUnitTypesAdapter.getSelectors(({ warehouseUnitTypes }) => warehouseUnitTypes);

export const getWarehouseUnitTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getWarehouseUnitTypes = (state) => getWarehouseUnitTypesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setWarehouseUnitTypes,
} = warehouseUnitTypesSlice.actions;

export default warehouseUnitTypesSlice.reducer;
